import React from 'react';
import Input from "../Input-new/Input";
import PropTypes from "prop-types";
import Dropdown from "../Dropdown/Dropdown";
import Textarea from "../Textarea-new/Textarea";
import Control from "../Control";
import DualRange from "../DualRange";
import SelectTeam from "../SelectTeam-new/SelectTeam";

const BuyerForm = ({theme = 'white', data, paneIndex, isFilter = false, handleSubmit, handleCancel, handleParentChange, handleParentDropdownChange, handlePaneChange}) => {
    const panes = [
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Buyer' : 'Add Buyer'}</div>
                <Input theme={theme}
                       valueType='text'
                       name='FIRST_NAME'
                       label='First Name'
                       value={data.FIRST_NAME}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='LAST_NAME'
                       label='Last Name'
                       value={data.LAST_NAME}
                       required={!isFilter}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='phone'
                       name='PHONE'
                       label='Phone'
                       value={data.PHONE}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='email'
                       name='EMAIL'
                       label='Email'
                       value={data.EMAIL}
                       handleParentChange={handleParentChange}
                />
                <Dropdown theme={theme}
                          optionsType='profiles'
                          value={data.PROFILE}
                          valueKey='PROFILE'
                          label='Profile'
                          data={data}
                          handleParentChange={handleParentDropdownChange}
                />
                <Dropdown theme={theme}
                          optionsType='buyerStatus'
                          value={data.STATUS}
                          valueKey='STATUS'
                          label='Buyer Status'
                          data={data}
                          handleParentChange={handleParentDropdownChange}
                />
                {
                    !isFilter &&
                    <div className='last-modified'>Buyer status last modified on: {data.LAST_MODIFIED}</div>
                }
                {
                    (data.STATUS || isFilter) &&
                    <React.Fragment>
                        <Dropdown theme={theme}
                                  dropdownType='multiple'
                                  optionsType='category'
                                  optionKey='code'
                                  optionLabelKey='name'
                                  value={data.CATEGORY}
                                  valueKey='CATEGORY'
                                  label='Category'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                        <Dropdown theme={theme}
                                  dropdownType='multiple'
                                  optionsType='type'
                                  optionKey='code'
                                  optionLabelKey='name'
                                  value={data.TYPE}
                                  valueKey='TYPE'
                                  label='Type'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                        {
                            data.TYPE === 'STNL,' &&
                            <Dropdown theme={theme}
                                      dropdownType='multiple'
                                      optionsType='subcategorySTNL'
                                      value={data.SINGLE_TENANT_SUBCATEGORY}
                                      valueKey='SINGLE_TENANT_SUBCATEGORY'
                                      label='Tenant Subcategory'
                                      data={data}
                                      handleParentChange={handleParentDropdownChange}
                            />
                        }
                        {
                            data.TYPE === 'MT,' &&
                            <Dropdown theme={theme}
                                      dropdownType='multiple'
                                      optionsType='subcategoryMT'
                                      value={data.MULTI_TENANT_SUBCATEGORY}
                                      valueKey='MULTI_TENANT_SUBCATEGORY'
                                      label='Tenant Subcategory'
                                      data={data}
                                      handleParentChange={handleParentDropdownChange}
                            />
                        }
                        <Dropdown theme={theme}
                                  dropdownType='multiple'
                                  optionsType='market'
                                  value={data.MARKET}
                                  valueKey='MARKET'
                                  label='Market'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                        <DualRange theme={theme}
                                   minValue={data.PRICE_MIN}
                                   maxValue={data.PRICE_MAX}
                                   minName='PRICE_MIN'
                                   maxName='PRICE_MAX'
                                   valueType='integer'
                                   label='Price Range'
                                   handleParentChange={handleParentChange}
                        />
                        <DualRange theme={theme}
                                   minValue={data.CAP_RATE_MIN}
                                   maxValue={data.CAP_RATE_MAX}
                                   minName='CAP_RATE_MIN'
                                   maxName='CAP_RATE_MAX'
                                   valueType='percent'
                                   label='Cap Rate Range'
                                   handleParentChange={handleParentChange}
                        />
                        <SelectTeam theme={theme}
                                    value={data.STRIVE_AGENT}
                                    valueKey='STRIVE_AGENT'
                                    label='Agent'
                                    data={data}
                                    handleParentChange={handleParentDropdownChange}
                        />
                    </React.Fragment>
                }
                <Textarea theme={theme}
                          name='NOTES'
                          label='Notes'
                          value={data.NOTES}
                          maxWidth='100%'
                          handleParentChange={handleParentChange}
                />
            </React.Fragment>
        ),
        (
            <React.Fragment>
                <div className={`form-title ${theme}`}>{isFilter ? 'Buyer Company' : 'Add Buyer Company'}</div>
                <Input theme={theme}
                       valueType='text'
                       name='COMPANY_NAME'
                       label='Company Name'
                       value={data.COMPANY_NAME}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='COMPANY_ADDRESS'
                       label='Company Address'
                       value={data.COMPANY_ADDRESS}
                       handleParentChange={handleParentChange}
                />
                <Input theme={theme}
                       valueType='text'
                       name='COMPANY_CITY'
                       label='City'
                       value={data.COMPANY_CITY}
                       handleParentChange={handleParentChange}
                />
                <div className='form-address'>
                    <div className='form-state'>
                        <Dropdown theme={theme}
                                  optionsType='states'
                                  optionKey='abbr'
                                  optionLabelKey='name'
                                  value={data.COMPANY_STATE}
                                  valueKey='COMPANY_STATE'
                                  label='State'
                                  data={data}
                                  handleParentChange={handleParentDropdownChange}
                        />
                    </div>
                    <div className='form-zip'>
                        <Input theme={theme}
                               valueType='text'
                               name='COMPANY_ZIP'
                               label='Zip'
                               value={data.COMPANY_ZIP}
                               handleParentChange={handleParentChange}
                        />
                    </div>
                </div>
            </React.Fragment>
        ),
    ];

    return (
        <form className='form' onSubmit={handleSubmit}>
            <div className='form-slider'>
                {
                    panes.map((el, key) => (
                        <Control key={key} onClick={()=> handlePaneChange(key)}>
                            <div className={`form-slider-icon ${theme}${key === paneIndex ? ' active' : ''}`}/>
                        </Control>
                    ))
                }
            </div>
            {
                panes[paneIndex]
            }
            {
                isFilter ?
                    <div className='filter-buttons'>
                        <button type='button' className='button-new negative dark' onClick={handleCancel}>Clear</button>
                        <button className='button-new positive'>Apply</button>
                    </div>
                    :
                    <React.Fragment>
                        <button type='button' className='button-new negative' onClick={handleCancel}>Cancel</button>
                        <button className='button-new positive'>Submit</button>
                    </React.Fragment>
            }
        </form>
    )
};

BuyerForm.propTypes = {
    theme: PropTypes.oneOf(['white', 'dark']),
    data: PropTypes.object.isRequired,
    paneIndex: PropTypes.number.isRequired,
    isFilter: PropTypes.bool,
    handleSubmit: PropTypes.func.isRequired,
    handleCancel: PropTypes.func.isRequired,
    handleParentChange: PropTypes.func.isRequired,
    handleParentDropdownChange: PropTypes.func.isRequired,
    handlePaneChange: PropTypes.func.isRequired,
};

export default BuyerForm;